import {
  PRODUCT_DETAIL_KITTING_PANEL,
  PRODUCT_SINGLE_URI_COMPONENT,
} from '../../common/constants/Products.js'
import handleListSelection from '../../common/handleListSelection.js'
import Checkbox from '../../common/components/Checkbox.js'
import ButtonPrimary from '../../common/components/Button/ButtonPrimary.js'
import LinkButton from '../../common/components/Link/LinkButton.js'
import ButtonLink from '../../common/components/Button/ButtonLink.js'
import {showProductComponentModal} from '../ProductListPage/Modals/ProductComponentModal.js'
import {showRemoveComponentModal} from '../ProductListPage/Modals/RemoveComponentModal.js'
import {
  hasUseMOsFeatureSelector,
  usesInventorySelector,
} from '../../data/company.js'
import {isBOMSelector} from '../../data/products.js'
import {updateProductDetailForm} from './productDetailActions.js'
import {
  productDetailFormSelector,
  skuSelector,
  kitComponentsSelector,
  kitComponentSKUsSelector,
  areAllKitComponentsSelectedSelector,
  areIndeterminateKitComponentsSelectedSelector,
} from './productDetailSelectors.js'
import {showCreatePOModal} from '../ProductListPage/Modals/CreatePOModal/createPOModalActions.js'
import ParentsPanel from './ParentsPanel.js'
import {useSelector} from '../../store.js'
import Icon from '../../common/icons/Icon.js'

export default function Kitting() {
  const form = useSelector(productDetailFormSelector)
  const sku = useSelector(skuSelector)
  const kitComponents = useSelector(kitComponentsSelector)
  const kitComponentSKUs = useSelector(kitComponentSKUsSelector)
  const areAllKitComponentsSelected = useSelector(
    areAllKitComponentsSelectedSelector,
  )
  const areIndeterminateKitComponentsSelected = useSelector(
    areIndeterminateKitComponentsSelectedSelector,
  )
  const isBOM = useSelector((state) => isBOMSelector(state, {sku}))
  const isKit = kitComponents.length > 0
  const hasUseMOsFeature = useSelector(hasUseMOsFeatureSelector)
  const usesInventory = useSelector(usesInventorySelector)

  const firstKitComponent = form.selectedKitComponentSKUs.length
    ? kitComponents.find(({sku}) => form.selectedKitComponentSKUs.includes(sku))
    : null

  const firstSelectedComponentQuantity = firstKitComponent
    ? firstKitComponent.quantity
    : null

  return (
    <div className="row flex">
      <div className="medium-9 columns padding-left-0">
        <div className="flex--justify align-items-center">
          <dl className="list">
            <dt className="list__title fs-01 lh-md">Kit Parent Info</dt>
            <dd className="list__item fs-00 margin-top-10 margin-bottom-20">
              {isBOM
                ? 'This product is a BOM and cannot contain kit components.'
                : isKit
                  ? 'This product is a kit parent.'
                  : 'This product is not currently a kit parent.'}
            </dd>
          </dl>
          <div>
            {form.selectedKitComponentSKUs.length > 0 && (
              <ButtonPrimary
                isOutlined
                size="sm"
                onClick={() => showCreatePOModal(form.selectedKitComponentSKUs)}
              >
                Order More Components
              </ButtonPrimary>
            )}
          </div>
        </div>
        {isKit && (
          <table className="table fs-00">
            <thead>
              <tr>
                <th className="table__th table__th--sm w-1">
                  {kitComponentSKUs.length === 0 ? (
                    ''
                  ) : (
                    <Checkbox
                      className="margin-bottom-0"
                      checked={areAllKitComponentsSelected}
                      indeterminate={areIndeterminateKitComponentsSelected}
                      onClick={(checked) =>
                        updateProductDetailForm({
                          selectedKitComponentSKUs: checked
                            ? kitComponentSKUs
                            : [],
                        })
                      }
                    />
                  )}
                </th>
                <th className="table__th table__th--md">Component Name</th>
                <th className="table__th table__th--md">SKU</th>
                {usesInventory && (
                  <>
                    <th className="table__th table__th--md align-right">
                      Phys On Hand
                    </th>
                    <th className="table__th table__th--md align-right">
                      Available
                    </th>
                  </>
                )}
                <th className="table__th table__th--md align-right">
                  {form.selectedKitComponentSKUs.length === 0 ? (
                    'Qty Needed for Kit'
                  ) : (
                    <ButtonLink
                      className="darker lh-md align-right"
                      title="Bulk Update Quantity Needed for Kit"
                      onClick={() =>
                        showProductComponentModal(
                          sku,
                          form.selectedKitComponentSKUs,
                          firstSelectedComponentQuantity,
                        )
                      }
                    >
                      Qty Needed for Kit
                    </ButtonLink>
                  )}
                </th>
                <th className="table__th table__th--md align-right">
                  {form.selectedKitComponentSKUs.length === 0 ? (
                    ''
                  ) : (
                    <ButtonLink
                      className="no-underline"
                      title="Remove component"
                      onClick={() =>
                        showRemoveComponentModal(
                          sku,
                          form.selectedKitComponentSKUs,
                        )
                      }
                    >
                      <Icon name="trash" className="fs-00" />
                    </ButtonLink>
                  )}
                </th>
              </tr>
            </thead>
            <tbody className="table__tbody table__tbody--lines">
              {kitComponents.map((kitComponent) => (
                <tr key={kitComponent.sku}>
                  <td className="table__td">
                    <Checkbox
                      key={kitComponent.sku}
                      className="margin-bottom-0"
                      checked={form.selectedKitComponentSKUs.includes(
                        kitComponent.sku,
                      )}
                      onClick={(checked, event) =>
                        updateProductDetailForm({
                          selectedKitComponentSKUs: handleListSelection({
                            value: kitComponent.sku,
                            isSelected: checked,
                            isShiftKey: event.shiftKey,
                            selected: form.selectedKitComponentSKUs,
                            list: kitComponentSKUs,
                          }),
                        })
                      }
                    />
                  </td>
                  <td className="table__td table__td--md">
                    <LinkButton
                      href={`#/${PRODUCT_SINGLE_URI_COMPONENT}/${encodeURIComponent(
                        kitComponent.sku,
                      )}/${PRODUCT_DETAIL_KITTING_PANEL}`}
                      className="darker v-align-base"
                    >
                      <strong>{kitComponent.name}</strong>
                    </LinkButton>
                  </td>
                  <td className="table__td table__td--md">
                    <LinkButton
                      href={`#/product/${encodeURIComponent(
                        kitComponent.sku,
                      )}/${PRODUCT_DETAIL_KITTING_PANEL}`}
                      className="darker v-align-base"
                    >
                      {kitComponent.sku}
                    </LinkButton>
                  </td>
                  {usesInventory && (
                    <>
                      <td className="table__td table__td--md align-right">
                        {kitComponent.total_on_hand}
                      </td>
                      <td className="table__td table__td--md align-right">
                        {kitComponent.total_available}
                      </td>
                    </>
                  )}
                  <td className="table__td table__td--md align-right">
                    <ButtonLink
                      className="darker v-align-base"
                      onClick={() =>
                        showProductComponentModal(
                          sku,
                          [kitComponent.sku],
                          kitComponent.quantity,
                        )
                      }
                    >
                      {kitComponent.quantity}
                    </ButtonLink>
                  </td>
                  <td className="table__td table__td--md align-right">
                    <ButtonLink
                      className="no-underline"
                      title="Remove kit component"
                      onClick={() =>
                        showRemoveComponentModal(sku, [kitComponent.sku])
                      }
                    >
                      <Icon name="trash" className="fs-00" />
                    </ButtonLink>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        {(kitComponents.length > 0 || !hasUseMOsFeature) && (
          <div className="align-center padding-top-15">
            <ButtonPrimary
              isOutlined
              size="sm"
              onClick={() => showProductComponentModal(sku)}
            >
              Add a Kit Component
            </ButtonPrimary>
          </div>
        )}
      </div>
      <div className="medium-3 columns border-left--light padding-right-0">
        <ParentsPanel />
      </div>
    </div>
  )
}
